(function($, root) {

  $.selectContent = function(content, subjectIndex) {
    content = (content === undefined) ? null : content;
    subjectIndex = (subjectIndex === undefined) ? null : subjectIndex;
    // content = content || null;
    // subjectIndex = subjectIndex || null;

    if (subjectIndex !== null) {
      // console.log('loading first subj');
      window.rdo.data.selected.content = window.rdo.data.selected.year.subjects[subjectIndex];
      window.rdo.data.selected.content.subject = true;
      $.prepareNextContent(1);
      // $.preparePrevContent(1);

    } else if (content !== null) {
      // console.log('loading given content');
      window.rdo.data.selected.content = window.rdo.data.selected.subject.contents[content - 1];
      window.rdo.data.selected.content.subject = false;
      $.prepareNextContent(window.rdo.data.selected.content.index + 1, null);
      // $.preparePrevContent(window.rdo.data.selected.content.index - 1, null);

    } else if (window.rdo.data.selected.subject.contents.length) {
      window.rdo.data.selected.content = window.rdo.data.selected.subject.contents[0];
      window.rdo.data.selected.content.subject = false;

      $.prepareNextContent(window.rdo.data.selected.content.index, null);
      // $.preparePrevContent(window.rdo.data.selected.content.index, null);

    } else {
      window.rdo.data.selected.content = null;

    }

    // console.log('selected content: ');
    // console.log(window.rdo.data.selected.content);

    $.showPage();

  }

  $.showPage = function() {

    if (!window.rdo.header.shown) {
      console.log('HEADER NOT SHOWN SO WE SHOW IT!');
      $.renderTimelinePlayer();
      window.rdo.header.shown = true;
    }

    $.renderTimelines();

    if (window.rdo.preloading == 'this') {
      console.log('SHOULD PRELOAD this');
      // wait until preload;
      window.rdo.preloadStatus = $.preloadContent(window.rdo.data.selected.content, 'this');
      $.waitUntilPreload();

    } else if (window.rdo.preloading == 'next') {
      console.log('SHOULD PRELOAD next');
      window.rdo.preloadStatus = $.preloadContent(window.rdo.data.next.content, 'next');
      $.renderContent();
    }

  }

  // $.preparePrevContent = function(contentIndex, subjectIndex, yearIndex) {
  //   contentIndex = (contentIndex === undefined) ? null : contentIndex;
  //   subjectIndex = (subjectIndex === undefined) ? null : subjectIndex;
  //   yearIndex = (yearIndex === undefined) ? null : yearIndex;
  //   let data = window.rdo.data;
  //   let selected = data.selected;
  //   let prev = data.prev;
  //
  //   if (contentIndex !== null) {
  //     if (selected.subject.contents.length >= contentIndex) {
  //       prev.content = selected.subject.contents[contentIndex - 1];
  //       prev.subject = selected.subject;
  //       prev.year = selected.year;
  //     } else {
  //       $.preparePrevContent(null, selected.subject.index + 1);
  //     }
  //
  //   } else if (subjectIndex !== null) {
  //     if (selected.year.subjects.length > subjectIndex) {
  //       prev.content = selected.year.subjects[subjectIndex];
  //       prev.subject = selected.year.subjects[subjectIndex];
  //       prev.year = selected.year;
  //     } else {
  //       $.preparePrevContent(null, null, selected.year.index + 1);
  //     }
  //   } else if (yearIndex !== null) {
  //     if (data.years.length > yearIndex) {
  //       prev.year = data.years[yearIndex];
  //       prev.subject = next.year.subjects[0];
  //       prev.content = next.subject;
  //       prev.content.subject = true;
  //     } else {
  //
  //       prev.year = data.years[0];
  //       prev.subject = next.year.subjects[0];
  //       prev.content = next.subject;
  //       prev.content.subject = true;
  //     }
  //   }
  // }

  $.prepareNextContent = function(contentIndex, subjectIndex, yearIndex) {
    contentIndex = (contentIndex === undefined) ? null : contentIndex;
    subjectIndex = (subjectIndex === undefined) ? null : subjectIndex;
    yearIndex = (yearIndex === undefined) ? null : yearIndex;
    let data = window.rdo.data;
    let selected = data.selected;
    let next = data.next;

    if (contentIndex !== null) {
      // console.log('cont. index ' + subjectIndex);
      if (selected.subject.contents.length >= contentIndex) {
        next.content = selected.subject.contents[contentIndex - 1];
        next.subject = selected.subject;
        next.year = selected.year;
        // window.rdo.preloadStatus = $.preloadNextContent();

      } else {
        $.prepareNextContent(null, selected.subject.index + 1);

      }

    } else if (subjectIndex !== null) {

      if (selected.year.subjects.length > subjectIndex) {

        next.content = selected.year.subjects[subjectIndex];
        next.subject = selected.year.subjects[subjectIndex];
        next.year = selected.year;
        // window.rdo.preloadStatus = $.preloadNextContent();

      } else {
        // console.log('next content is subject detail');
        $.prepareNextContent(null, null, selected.year.index + 1);

      }

    } else if (yearIndex !== null) {
      if (data.years.length > yearIndex) {
        next.year = data.years[yearIndex];
        next.subject = next.year.subjects[0];
        next.content = next.subject;
        next.content.subject = true;
        // window.rdo.preloadStatus = $.preloadNextContent();

      } else {

        next.year = data.years[0];

        next.subject = next.year.subjects[0];
        next.content = next.subject;
        next.content.subject = true;
        // window.rdo.preloadStatus = $.preloadNextContent();
      }

    }

    // console.log('next content is: ');
    // console.log(next.content);

    // console.log('next year is:' + next.year.year);
    // console.log('next subject is:' + next.subject.post_title);
    // console.log('next content is:' + next.subject.post_title);
    //
  }

  $.getNextToNow = function() {
    window.rdo.data.selected.year = window.rdo.data.next.year;
    window.rdo.data.selected.subject = window.rdo.data.next.subject;
    window.rdo.data.selected.content = window.rdo.data.next.content;
  }

  // $.getPrevToNow = function() {
  //   window.rdo.data.selected.year = window.rdo.data.prev.year;
  //   window.rdo.data.selected.subject = window.rdo.data.prev.subject;
  //   window.rdo.data.selected.content = window.rdo.data.prev.content;
  // }

  $.selectSubject = function(subject, content) {
    subject = (subject === undefined) ? null : subject;
    content = content || null;
    // subject = subject || null;

    if (subject !== null) {
      // console.log('subejct is:' + subject);
      //select given subject with subject index
      window.rdo.data.selected.subject = window.rdo.data.selected.year.subjects[subject];
      // console.log('this subject is selected: ' + subject);
    } else if (window.rdo.data.selected.year.subjects.length) {
      // select first subject in selected year:
      window.rdo.data.selected.subject = window.rdo.data.selected.year.subjects[0];
      subject = 0;
      // console.log('this subject is selected: ' + 0);
    } else {
      //there are no subjects in selected year:
      window.rdo.data.selected.subject = null;
      // console.log('no subject is selected: ');
    }
    if (content) {
      subject = null;
    }
    $.selectContent(content, subject);
  }

  $.selectYear = function(year, subject, content) {
    year = (year === undefined) ? null : year;
    subject = subject || null;
    content = content || null;
    window.rdo.preloading = 'this';

    window.rdo.data.selected = {
      year: null,
      subject: null,
      content: null
    };

    window.rdo.data.next = {
      year: null,
      subject: null,
      content: null
    };

    window.rdo.data.prev = {
      year: null,
      subject: null,
      content: null
    };

    if (year !== null) {
      //select given year:
      window.rdo.data.selected.year = window.rdo.data.years[year];
      // console.log('selected year: ' + year);
      // console.log('this year is selected: ' + year);
    } else if (window.rdo.data.years.length) {
      //select first year:
      window.rdo.data.selected.year = window.rdo.data.years[0];
      // console.log('this year is selected: ' + 0);
    } else {
      //no year:
      window.rdo.data.selected.year = null;
      // console.log('no year is selected: ');
    }

    $.selectSubject(subject, content);

  }

  $.moveNextContent = function() {
    // console.log('moving to next content');
    $.getNextToNow();

    if (window.rdo.data.selected.content.subject) {
      $.selectContent(null, window.rdo.data.selected.subject.index);

    } else {

      $.selectContent(window.rdo.data.selected.content.index);

    }

  }

  // $.movePrevContent = function() {
  //   // console.log('moving to next content');
  //   $.getPrevToNow();
  //
  //   if (window.rdo.data.selected.content.subject) {
  //     $.selectContent(null, window.rdo.data.selected.subject.index);
  //
  //   } else {
  //
  //     $.selectContent(window.rdo.data.selected.content.index);
  //
  //   }
  //
  // }

  $.initSelections = function() {
    console.log('initing selections');
    window.rdo.preloading = 'this';
    console.log(window.rdo.data);
    $.selectYear();

    //make the selections for the first time:
    // if (window.rdo.data.selected === undefined) {
    //   console.log('selecting from scratch');
    //   $.selectYear();
    // } else {
    //   if (window.rdo.data.selected.content.subject) {
    //     console.log('subject selected');
    //     $.selectContent(null, window.rdo.data.selected.subject.index);
    //   } else {
    //     console.log('content selected');
    //     $.selectContent(window.rdo.data.selected.content.index);
    //   }
    //
    // }

  };

  //content mode:
  $('html').on('click touch', '.show-content #vertical-timeline .year-title', function() {
    window.rdo.preloading = 'this';
    //when a year is clicked on vertical timeline:
    let year = $(this).attr('data-index');

    $.selectYear(year);

    // $.resetTimer();

  });

  $('html').on('click touchstart', '.show-content #horizontal-timeline ul li point', function() {
    window.rdo.preloading = 'this';
    //when a content is clicked on horizontal timeline:
    let content = $(this).parent().attr('data-index');

    if (content == 0) {
      let subject = $(this).parent().attr('data-subject-index');
      $.selectSubject(subject);
    } else {
      // console.log('selecting content:' + content);
      $.selectContent(content);
    }
    // $.resetTimer();
  });

  $('html').on('click touchstart', '.show-content #vertical-timeline .subject-line', function() {
    window.rdo.preloading = 'this';
    //when a subject is clicked on vertical timeline:
    let subject = $(this).attr('data-index');
    let year = $(this).attr('data-year-index');

    // console.log('ix is:' + index);
    $.selectYear(year, subject);

    // $.resetTimer();
  });

  // $('html').on('click touchstart', '.move-previous', function() {
  //   $.movePrevContent();
  // });

  $('html').on('click touchstart', '.move-next', function() {
    $.moveNextContent();
  });

  $('html').on('click touchstart', '.amblem', function() {
    $.selectYear(0, 0, 0);
  });

})(jQuery, this);
